'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Base,
    WebSocketRuntime,
    platform,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

Base = require('./base');

platform = require('../helpers/platform');

WebSocketRuntime = function (_Base) {
  _inherits(WebSocketRuntime, _Base);

  function WebSocketRuntime(definition) {
    _classCallCheck(this, WebSocketRuntime);

    var _this = _possibleConstructorReturn(this, (WebSocketRuntime.__proto__ || Object.getPrototypeOf(WebSocketRuntime)).call(this, definition));

    _this.handleError = _this.handleError.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.connecting = false;
    _this.connection = null;
    _this.protocol = 'noflo';
    _this.buffer = [];
    _this.container = null;
    return _this;
  }

  _createClass(WebSocketRuntime, [{
    key: 'getElement',
    value: function getElement() {
      var messageConsole, previewImage;
      if (this.container) {
        return this.container;
      }
      // DOM visualization for remote runtime output
      this.container = document.createElement('div');
      this.container.classList.add('preview-container');
      messageConsole = document.createElement('pre');
      previewImage = document.createElement('img');
      this.container.appendChild(previewImage);
      this.container.appendChild(messageConsole);
      this.on('network', function (message) {
        var encoded, hasQuery, p, separator;
        if (message.command !== 'output') {
          return;
        }
        p = message.payload;
        if (p.type != null && p.type === 'previewurl') {
          hasQuery = p.url.indexOf('?' !== -1);
          separator = hasQuery ? '&' : '?';
          previewImage.src = p.url + separator + 'timestamp=' + new Date().getTime();
        }
        if (p.message != null) {
          encoded = p.message.replace(/[\u00A0-\u99999<>\&]/gim, function (i) {
            return '&#' + i.charCodeAt(0) + ';';
          });
          messageConsole.innerHTML += encoded + '\n';
          return messageConsole.scrollTop = messageConsole.scrollHeight;
        }
      });
      this.on('disconnected', function () {
        return messageConsole.innerHTML = '';
      });
      return this.container;
    }
  }, {
    key: 'isConnected',
    value: function isConnected() {
      return this.connection && this.connecting === false;
    }
  }, {
    key: 'connect',
    value: function connect() {
      var _this2 = this;

      if (this.connection || this.connecting) {
        return;
      }
      if (this.protocol) {
        this.connection = new platform.WebSocket(this.getAddress(), this.protocol);
      } else {
        this.connection = new platform.WebSocket(this.getAddress());
      }
      this.connection.addEventListener('open', function () {
        _this2.connecting = false;
        // Perform capability discovery
        _this2.sendRuntime('getruntime', {});
        _this2.emit('status', {
          online: true,
          label: 'connected'
        });
        _this2.emit('connected');
        return _this2.flush();
      }, false);
      this.connection.addEventListener('message', this.handleMessage, false);
      this.connection.addEventListener('error', this.handleError, false);
      this.connection.addEventListener('close', function () {
        _this2.connection = null;
        _this2.emit('status', {
          online: false,
          label: 'disconnected'
        });
        return _this2.emit('disconnected');
      }, false);
      return this.connecting = true;
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      if (!this.connection) {
        return;
      }
      this.connecting = false;
      return this.connection.close();
    }
  }, {
    key: 'send',
    value: function send(protocol, command, payload) {
      if (this.connecting) {
        this.buffer.push({
          protocol: protocol,
          command: command,
          payload: payload
        });
        return;
      }
      if (!this.connection) {
        return;
      }
      return this.connection.send(JSON.stringify({
        protocol: protocol,
        command: command,
        payload: payload
      }));
    }
  }, {
    key: 'handleError',
    value: function handleError(error) {
      var _this3 = this;

      boundMethodCheck(this, WebSocketRuntime);
      if (this.protocol === 'noflo') {
        delete this.protocol;
        this.connecting = false;
        this.connection = null;
        setTimeout(function () {
          return _this3.connect();
        }, 1);
        return;
      }
      this.emit('error', error);
      this.connection = null;
      return this.connecting = false;
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage(message) {
      var msg;
      boundMethodCheck(this, WebSocketRuntime);
      msg = JSON.parse(message.data);
      return this.recvMessage(msg);
    }
  }, {
    key: 'flush',
    value: function flush() {
      var item, j, len, ref;
      ref = this.buffer;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        this.send(item.protocol, item.command, item.payload);
      }
      return this.buffer = [];
    }
  }]);

  return WebSocketRuntime;
}(Base);

module.exports = WebSocketRuntime;